export const DefaultOrder = () => JSON.parse(JSON.stringify(
    {main: {extras: [], requirements: [], id:0, value: {}, defaultSelection: []}, sides: [], dips:[], drinks:[], price: 0}));
